<template>
  <!-- 3D画布右上角空间音频切换组件 -->
  <div class="container">
    <div
      :class="
        isOpen ? 'switchStyle color_bg_true' : 'switchStyle color_bg_false'
      "
    >
      <div class="listenPosition"></div>
      <div class="elSwitch" @click="switchPos">
        <div class="pointStyle" ref="pointPos"></div>
      </div>
      <div class="textSty">{{ textDisc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SwitchCom",
  props: [],
  data() {
    return {
      value: true,
      isOpen: true,
      textDisc: "开启空间音频",
    };
  },
  components: {},
  mounted() {},
  methods: {
    switchPos() {
      if (this.isOpen) {
        this.$refs.pointPos.style.left = "4px";
        this.$refs.pointPos.style.background = "#595959";
        this.textDisc = "关闭空间音频";
      } else {
        this.$refs.pointPos.style.left = "14px";
        this.$refs.pointPos.style.background = "#3D3DFC";
        this.textDisc = "开启空间音频";
      }
      this.isOpen = !this.isOpen;
      this.$parent.isShowSpaceAudio = this.isOpen;
    },
  },
  watch: {},
  computed: {},
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.switchStyle {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 202px;
  height: 44px;
  border-radius: 6px;

  display: flex;
  flex-direction: column;
  justify-content: center;
}
.color_bg_true {
  background: #3d3dfc;
  box-shadow: 0px 3px 6px rgba(5, 5, 86, 0.3), inset 0px -1px 0px #1616ed;
}
.color_bg_false {
  background: rgba(0, 0, 0, 0.6);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3),
    inset 0px -1px 0px rgba(0, 0, 0, 0.3);
}
.listenPosition {
  position: absolute;
  left: 24px;
  width: 24px;
  height: 24px;

  background-image: url("/space/images/sound.svg");
  background-repeat: no-repeat;
  background-size: contain;
}
.elSwitch {
  position: absolute;
  left: 58px;
  width: 28px;
  height: 18px;
  border-radius: 10px;
  background: rgb(255, 255, 255);
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: center;
}
.pointStyle {
  position: absolute;
  left: 14px;
  width: 10px;
  height: 10px;
  border-radius: 10px;

  background: #3d3dfc;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
.textSty {
  position: absolute;
  left: 94px;

  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  text-align: justify;
  color: #ffffff;
  mix-blend-mode: normal;
  flex: none;
  order: 1;
  flex-grow: 0;
}
</style>
